window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Andrea_Side_Neutral_Open = function() {
	this.initialize(img.MainAssets_Andrea_Side_Neutral_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,461,664);


(lib.Artboard36 = function() {
	this.initialize(img.MainAssets_Artboard36);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,495,357);


(lib.Balloon01 = function() {
	this.initialize(img.MainAssets_Balloon01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1022,517);


(lib.balloontail = function() {
	this.initialize(img.MainAssets_balloontail);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,132,140);


(lib.Button_disabled = function() {
	this.initialize(img.MainAssets_Button_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_down = function() {
	this.initialize(img.MainAssets_Button_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_up = function() {
	this.initialize(img.MainAssets_Button_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.CharacterShadow = function() {
	this.initialize(img.MainAssets_CharacterShadow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,294,163);


(lib.CloseButtonDis = function() {
	this.initialize(img.MainAssets_CloseButtonDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,152,97);


(lib.CloseButtonhi = function() {
	this.initialize(img.MainAssets_CloseButtonhi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,152,97);


(lib.CloseButtonUp = function() {
	this.initialize(img.MainAssets_CloseButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,153,97);


(lib.deskGambit = function() {
	this.initialize(img.MainAssets_deskGambit);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1166,998);


(lib.DialogButtonHi = function() {
	this.initialize(img.MainAssets_DialogButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1013,123);


(lib.DialogButtonLo = function() {
	this.initialize(img.MainAssets_DialogButtonLo);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1013,123);


(lib.DialogButtonsPanelBG = function() {
	this.initialize(img.MainAssets_DialogButtonsPanelBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1046,413);


(lib.DialogButtonUp = function() {
	this.initialize(img.MainAssets_DialogButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1013,123);


(lib.Episode1Image = function() {
	this.initialize(img.MainAssets_Episode1Image);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,313,213);


(lib.Episode1ImageDone = function() {
	this.initialize(img.MainAssets_Episode1ImageDone);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,313,213);


(lib.Episode2Image = function() {
	this.initialize(img.MainAssets_Episode2Image);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,297,213);


(lib.Episode2ImageDone = function() {
	this.initialize(img.MainAssets_Episode2ImageDone);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,296,213);


(lib.episode3Image = function() {
	this.initialize(img.MainAssets_episode3Image);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,322,224);


(lib.Episode3ImageDOne = function() {
	this.initialize(img.MainAssets_Episode3ImageDOne);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,322,224);


(lib.Episode4Image = function() {
	this.initialize(img.MainAssets_Episode4Image);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,285,186);


(lib.Episode4ImageDone = function() {
	this.initialize(img.MainAssets_Episode4ImageDone);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,285,186);


(lib.Episode5Image = function() {
	this.initialize(img.MainAssets_Episode5Image);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,189,222);


(lib.Episode5ImageDone = function() {
	this.initialize(img.MainAssets_Episode5ImageDone);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,189,222);


(lib.EpisodeButtonDis = function() {
	this.initialize(img.MainAssets_EpisodeButtonDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,951,212);


(lib.EpisodeButtonHi = function() {
	this.initialize(img.MainAssets_EpisodeButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,951,212);


(lib.EpisodeButtonLo = function() {
	this.initialize(img.MainAssets_EpisodeButtonLo);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,951,212);


(lib.EpisodeButtonUp = function() {
	this.initialize(img.MainAssets_EpisodeButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,951,212);


(lib.EpisodeSelectBGPanel = function() {
	this.initialize(img.MainAssets_EpisodeSelectBGPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1043,1203);


(lib.Eye_Front_Open = function() {
	this.initialize(img.MainAssets_Eye_Front_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,32,36);


(lib.factory1 = function() {
	this.initialize(img.MainAssets_factory1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1278,993);


(lib.factory2 = function() {
	this.initialize(img.MainAssets_factory2);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,435,917);


(lib.factory3 = function() {
	this.initialize(img.MainAssets_factory3);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,139,1170);


(lib.factory4b = function() {
	this.initialize(img.MainAssets_factory4b);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,796,1566);


(lib.factory7b = function() {
	this.initialize(img.MainAssets_factory7b);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1233,1596);


(lib.FeedbackPanelBg = function() {
	this.initialize(img.MainAssets_FeedbackPanelBg);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,225,75);


(lib.gambit = function() {
	this.initialize(img.MainAssets_gambit);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,492,657);


(lib.gambit_1 = function() {
	this.initialize(img.MainAssets_gambit_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,232,310);


(lib.Gambit_Back = function() {
	this.initialize(img.MainAssets_Gambit_Back);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,930,1113);


(lib.gambit_closed = function() {
	this.initialize(img.MainAssets_gambit_closed);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,492,657);


(lib.Ground_Iso = function() {
	this.initialize(img.MainAssets_Ground_Iso);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1335,1539);


(lib.Ground_Straight = function() {
	this.initialize(img.MainAssets_Ground_Straight);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1334,1568);


(lib.LongerMainButtonDis = function() {
	this.initialize(img.MainAssets_LongerMainButtonDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonDown = function() {
	this.initialize(img.MainAssets_LongerMainButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonHi = function() {
	this.initialize(img.MainAssets_LongerMainButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.LongerMainButtonUp = function() {
	this.initialize(img.MainAssets_LongerMainButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,518,126);


(lib.MainButtonDis = function() {
	this.initialize(img.MainAssets_MainButtonDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonDown = function() {
	this.initialize(img.MainAssets_MainButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonHi = function() {
	this.initialize(img.MainAssets_MainButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.MainButtonUp = function() {
	this.initialize(img.MainAssets_MainButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,419,126);


(lib.Man1_Brow = function() {
	this.initialize(img.MainAssets_Man1_Brow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,52,10);


(lib.Man1_Front_Base = function() {
	this.initialize(img.MainAssets_Man1_Front_Base);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,441,655);


(lib.MCButtonDown = function() {
	this.initialize(img.MainAssets_MCButtonDown);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,496,357);


(lib.MCButtonHi = function() {
	this.initialize(img.MainAssets_MCButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,495,357);


(lib.Megan_Side_Neutral_Open = function() {
	this.initialize(img.MainAssets_Megan_Side_Neutral_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,553,664);


(lib.MSAnswersBGPanel = function() {
	this.initialize(img.MainAssets_MSAnswersBGPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1052,1333);


(lib.NarratorTextBGPanel = function() {
	this.initialize(img.MainAssets_NarratorTextBGPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1012,161);


(lib.Paul_Side_Neutral_Open = function() {
	this.initialize(img.MainAssets_Paul_Side_Neutral_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,462,664);


(lib.Plant5 = function() {
	this.initialize(img.MainAssets_Plant5);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,586,789);


(lib.PrevNextButton = function() {
	this.initialize(img.MainAssets_PrevNextButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_disabled = function() {
	this.initialize(img.MainAssets_PrevNextButton_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_down = function() {
	this.initialize(img.MainAssets_PrevNextButton_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.ProgressDot = function() {
	this.initialize(img.MainAssets_ProgressDot);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,31,31);


(lib.ProgressDot_Selected = function() {
	this.initialize(img.MainAssets_ProgressDot_Selected);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,31,31);


(lib.QuestionTextFieldBG = function() {
	this.initialize(img.MainAssets_QuestionTextFieldBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,984,138);


(lib.Robert_Side_Neutral_Open = function() {
	this.initialize(img.MainAssets_Robert_Side_Neutral_Open);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,462,663);


(lib.Shadow_Front = function() {
	this.initialize(img.MainAssets_Shadow_Front);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,700,741);


(lib.SplashBGPanel = function() {
	this.initialize(img.MainAssets_SplashBGPanel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1002,739);


(lib.StategyButtonHi = function() {
	this.initialize(img.MainAssets_StategyButtonHi);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,988,125);


(lib.StrategyButtonLo = function() {
	this.initialize(img.MainAssets_StrategyButtonLo);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,988,125);


(lib.StrategyButtonUp = function() {
	this.initialize(img.MainAssets_StrategyButtonUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,988,125);


(lib.TabButtonBGTT = function() {
	this.initialize(img.MainAssets_TabButtonBGTT);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,205,101);


(lib.TabButtonIconTTCastDis = function() {
	this.initialize(img.MainAssets_TabButtonIconTTCastDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,92,109);


(lib.TabButtonIconTTCastUp = function() {
	this.initialize(img.MainAssets_TabButtonIconTTCastUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,92,109);


(lib.TabButtonIconTTStoryDis = function() {
	this.initialize(img.MainAssets_TabButtonIconTTStoryDis);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,71,109);


(lib.TabButtonIconTTStoryUp = function() {
	this.initialize(img.MainAssets_TabButtonIconTTStoryUp);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,71,109);


(lib.Teamtacticsepisodeselectsmaller = function() {
	this.initialize(img.MainAssets_Teamtacticsepisodeselectsmaller);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,360,581);


(lib.textBalloon = function() {
	this.initialize(img.MainAssets_textBalloon);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,984,175);


(lib.vinkje = function() {
	this.initialize(img.MainAssets_vinkje);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,85,85);


(lib.watercooler01 = function() {
	this.initialize(img.MainAssets_watercooler01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,349,724);


(lib.WhiteArrow = function() {
	this.initialize(img.MainAssets_WhiteArrow);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,73,61);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.watercooler = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.watercooler01();
	this.instance.setTransform(0,0,0.8655,0.8655);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.watercooler, new cjs.Rectangle(0,0,302.1,626.7), null);


(lib.StoryPanelButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.TabButtonIconTTStoryUp();
	this.instance.setTransform(63,-2);

	this.instance_1 = new lib.TabButtonIconTTStoryDis();
	this.instance_1.setTransform(61,-2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).wait(1));

	// Layer_1
	this.instance_2 = new lib.TabButtonBGTT();

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-2,205,109);


(lib.Plant_5 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Plant5();
	this.instance.setTransform(-273,-755);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Plant_5, new cjs.Rectangle(-273,-755,586,789), null);


(lib.IntrospectionThoughtBubbles = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.balloontail();
	this.instance.setTransform(-10,-3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.IntrospectionThoughtBubbles, new cjs.Rectangle(-10,-3,132,140), null);


(lib.ConversationScalableButtonUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("max 3 lines, lines will vertically centereddddddd", "39px 'Poppins'", "#0E5184");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 58;
	this.textfield.lineWidth = 933;
	this.textfield.parent = this;
	this.textfield.setTransform(44.4,28.4);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.DialogButtonUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationScalableButtonUp, new cjs.Rectangle(0,0,1013,123), null);


(lib.ConversationScalableButtonOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("max 3 lines, lines will vertically centereddddddd", "39px 'Poppins'", "#0E5184");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 58;
	this.textfield.lineWidth = 933;
	this.textfield.parent = this;
	this.textfield.setTransform(44.4,28.4);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.DialogButtonHi();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationScalableButtonOver, new cjs.Rectangle(0,0,1013,123), null);


(lib.ConversationScalableButtonDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("max 3 lines, lines will vertically centereddddddd", "39px 'Poppins'", "#0E5184");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 58;
	this.textfield.lineWidth = 933;
	this.textfield.parent = this;
	this.textfield.setTransform(44.4,28.4);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.DialogButtonLo();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationScalableButtonDown, new cjs.Rectangle(0,0,1013,123), null);


(lib.ConversationScalableButtonDisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("max 3 lines, lines will vertically centereddddddd", "39px 'Poppins'", "#0E5184");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 58;
	this.textfield.lineWidth = 933;
	this.textfield.parent = this;
	this.textfield.setTransform(44.4,28.4);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.DialogButtonUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ConversationScalableButtonDisabled, new cjs.Rectangle(0,0,1013,123), null);


(lib.buttonHitArea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(191,191,191,0)").ss(1,1,1).p("Eg77gWXMB33AAAQF1AAEHEIQEIEIAAF0IAAQnQAAF0kIEIQkHEIl1AAMh33AAAQl1AAkIkIQkHkIAAl0IAAwnQAAl0EHkIQEIkIF1AAg");
	this.shape.setTransform(464.2649,126.303,0.9829,0.8905);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(51,51,51,0.008)").s().p("Eg77AWYQl1AAkIkIQkHkIAAl0IAAwnQAAl0EHkIQEIkIF1AAMB33AAAQF1AAEHEIQEIEIAAF0IAAQnQAAF0kIEIQkHEIl1AAg");
	this.shape_1.setTransform(464.2649,126.303,0.9829,0.8905);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.buttonHitArea, new cjs.Rectangle(-2.2,-2.2,933,257), null);


(lib.NarratorTextPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("Instructions here Instructions hereiiiiiiiiiiiiiiiiiiiiiii", "39px 'Poppins'", "#0F5184");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 59;
	this.textfield.lineWidth = 884;
	this.textfield.parent = this;
	this.textfield.setTransform(70.25,41.998);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg
	this.instance = new lib.NarratorTextBGPanel();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.NarratorTextPanel, new cjs.Rectangle(0,0,1012,161), null);


(lib.IntrospectionScalableButtonUp = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("has changed, is now vertically adjustablelllllllll", "39px 'Poppins'", "#0E5184");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 58;
	this.textfield.lineWidth = 910;
	this.textfield.parent = this;
	this.textfield.setTransform(43,26);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bitmap
	this.instance = new lib.StrategyButtonUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.IntrospectionScalableButtonUp, new cjs.Rectangle(0,0,988,125), null);


(lib.IntrospectionScalableButtonOver = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("has changed, is now vertically adjustablelllllllll", "39px 'Poppins'", "#0E5184");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 58;
	this.textfield.lineWidth = 910;
	this.textfield.parent = this;
	this.textfield.setTransform(43,27);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bitmap
	this.instance = new lib.StategyButtonHi();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.IntrospectionScalableButtonOver, new cjs.Rectangle(0,0,988,125), null);


(lib.IntrospectionScalableButtonDown = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("has changed, is now vertically adjustablelllllllll", "39px 'Poppins'", "#0E5184");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 58;
	this.textfield.lineWidth = 910;
	this.textfield.parent = this;
	this.textfield.setTransform(43,27);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bitmap
	this.instance = new lib.StrategyButtonLo();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.IntrospectionScalableButtonDown, new cjs.Rectangle(0,0,988,125), null);


(lib.IntrospectionScalableButtonDisabled = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// textfield
	this.textfield = new cjs.Text("has changed, is now vertically adjustablelllllllll", "39px 'Poppins'", "#0E5184");
	this.textfield.name = "textfield";
	this.textfield.lineHeight = 58;
	this.textfield.lineWidth = 910;
	this.textfield.parent = this;
	this.textfield.setTransform(43,27);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bitmap
	this.instance = new lib.StrategyButtonUp();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.IntrospectionScalableButtonDisabled, new cjs.Rectangle(0,0,988,125), null);


(lib.Gambit = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.gambit();
	this.instance.setTransform(107.65,-297,0.4871,0.4871,0,0,180);

	this.instance_1 = new lib.gambit_closed();
	this.instance_1.setTransform(107.65,-297,0.4871,0.4871,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},189).to({state:[{t:this.instance}]},10).wait(301));

	// Layer_2
	this.instance_2 = new lib.CharacterShadow();
	this.instance_2.setTransform(-147,-82);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(500));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-147,-297,294,378);


(lib.Eyes_Blinking = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Eye_Front_Open();
	this.instance.setTransform(44,-18);

	this.instance_1 = new lib.Eye_Front_Open();
	this.instance_1.setTransform(-76,-18);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1,p:{scaleY:1,y:-18}},{t:this.instance,p:{scaleY:1,y:-18}}]}).to({state:[{t:this.instance_1,p:{scaleY:0.1389,y:-3}},{t:this.instance,p:{scaleY:0.1389,y:-3}}]},119).to({state:[{t:this.instance_1,p:{scaleY:1,y:-18}},{t:this.instance,p:{scaleY:1,y:-18}}]},10).to({state:[{t:this.instance_1,p:{scaleY:1,y:-18}},{t:this.instance,p:{scaleY:1,y:-18}}]},370).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-76,-18,152,36);


(lib.EpisodeImages = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {episode1:0,episode2:1,episode3:2,episode4:3,episode5:4,episode1Disabled:5,episode2Disabled:6,episode3Disabled:7,episode4Disabled:8,episode5Disabled:9};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Episode1Image();
	this.instance.setTransform(-168,-104);

	this.instance_1 = new lib.Episode2Image();
	this.instance_1.setTransform(-174,-115);

	this.instance_2 = new lib.episode3Image();
	this.instance_2.setTransform(-161,-112);

	this.instance_3 = new lib.Episode4Image();
	this.instance_3.setTransform(-153,-87);

	this.instance_4 = new lib.Episode5Image();
	this.instance_4.setTransform(-106,-112);

	this.instance_5 = new lib.Episode1ImageDone();
	this.instance_5.setTransform(-168,-104);

	this.instance_6 = new lib.Episode2ImageDone();
	this.instance_6.setTransform(-174,-115);

	this.instance_7 = new lib.Episode3ImageDOne();
	this.instance_7.setTransform(-161,-112);

	this.instance_8 = new lib.Episode4ImageDone();
	this.instance_8.setTransform(-153,-87);

	this.instance_9 = new lib.Episode5ImageDone();
	this.instance_9.setTransform(-106,-112);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).to({state:[{t:this.instance_5}]},1).to({state:[{t:this.instance_6}]},1).to({state:[{t:this.instance_7}]},1).to({state:[{t:this.instance_8}]},1).to({state:[{t:this.instance_9}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-174,-115,335,227);


(lib.deskGambit_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.deskGambit();
	this.instance.setTransform(-582.5,-539);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.deskGambit_1, new cjs.Rectangle(-582.5,-539,1166,998), null);


(lib.chimney = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory3();
	this.instance.setTransform(-69.5,-585);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.chimney, new cjs.Rectangle(-69.5,-585,139,1170), null);


(lib.CastPanelButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.TabButtonIconTTCastUp();
	this.instance.setTransform(63,-2);

	this.instance_1 = new lib.TabButtonIconTTCastDis();
	this.instance_1.setTransform(61,-2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},3).wait(1));

	// Layer_1
	this.instance_2 = new lib.TabButtonBGTT();

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-2,205,109);


(lib.BalloonNPCtutorial = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bodyTextfield = new cjs.Text("NPC text here eiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii\nLine2\nLine3\netc\nLine5\nLine6", "40px 'Arial'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 73;
	this.bodyTextfield.lineWidth = 968;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-475.3,-261.2);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.instance = new lib.Balloon01();
	this.instance.setTransform(-499,-294);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.bodyTextfield}]}).wait(1));

	// Layer_4
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("AgeAgIA9g9IgLgC");
	this.shape.setTransform(289.85,-277.125);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BalloonNPCtutorial, new cjs.Rectangle(-499,-294,1022,540.3), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);


(lib.BioRobert = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Robert_Side_Neutral_Open();
	this.instance.setTransform(-58,-186,0.2922,0.2922);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bioTextfield
	this.bioTextfield = new cjs.Text("This is you! A senior employee at Life is Sweet and team leader of Team Chocolatexxxx", "39px 'Poppins'", "#0F5184");
	this.bioTextfield.name = "bioTextfield";
	this.bioTextfield.lineHeight = 54;
	this.bioTextfield.lineWidth = 744;
	this.bioTextfield.parent = this;
	this.bioTextfield.setTransform(135.4438,-182.951);
ranj.TextOffsetFixer.fix(this.bioTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bioTextfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BioRobert, new cjs.Rectangle(-58,-186,939.3,233.4), null);


(lib.BioMegan = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Megan_Side_Neutral_Open();
	this.instance.setTransform(-58,-186,0.2922,0.2922);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bioTextfield
	this.bioTextfield = new cjs.Text("This is you! A senior employee at Life is Sweet and team leader of Team Chocolatexxxx", "39px 'Poppins'", "#0F5184");
	this.bioTextfield.name = "bioTextfield";
	this.bioTextfield.lineHeight = 54;
	this.bioTextfield.lineWidth = 744;
	this.bioTextfield.parent = this;
	this.bioTextfield.setTransform(135.4438,-182.951);
ranj.TextOffsetFixer.fix(this.bioTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bioTextfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BioMegan, new cjs.Rectangle(-58,-186,939.3,237.7), null);


(lib.BioJames = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Paul_Side_Neutral_Open();
	this.instance.setTransform(-58,-186,0.2922,0.2922);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bioTextfield
	this.bioTextfield = new cjs.Text("This is you! A senior employee at Life is Sweet and team leader of Team Chocolatexxxx", "39px 'Poppins'", "#0F5184");
	this.bioTextfield.name = "bioTextfield";
	this.bioTextfield.lineHeight = 54;
	this.bioTextfield.lineWidth = 741;
	this.bioTextfield.parent = this;
	this.bioTextfield.setTransform(135.4438,-182.951);
ranj.TextOffsetFixer.fix(this.bioTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bioTextfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BioJames, new cjs.Rectangle(-58,-186,936.5,248.4), null);


(lib.BioGambit = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.gambit_1();
	this.instance.setTransform(70.2,-186,0.6,0.6,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bioTextfield
	this.bioTextfield = new cjs.Text("This is you! A senior employee at Life is Sweet and team leader of Team Chocolatexxxx", "39px 'Poppins'", "#0F5184");
	this.bioTextfield.name = "bioTextfield";
	this.bioTextfield.lineHeight = 54;
	this.bioTextfield.lineWidth = 744;
	this.bioTextfield.parent = this;
	this.bioTextfield.setTransform(135.4438,-182.951);
ranj.TextOffsetFixer.fix(this.bioTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bioTextfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BioGambit, new cjs.Rectangle(-69,-186,950.3,233.4), null);


(lib.BioEllis = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Andrea_Side_Neutral_Open();
	this.instance.setTransform(-58,-186,0.2922,0.2922);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bioTextfield
	this.bioTextfield = new cjs.Text("This is you! A senior employee at Life is Sweet and team leader of Team Chocolatexxxx", "39px 'Poppins'", "#0F5184");
	this.bioTextfield.name = "bioTextfield";
	this.bioTextfield.lineHeight = 54;
	this.bioTextfield.lineWidth = 741;
	this.bioTextfield.parent = this;
	this.bioTextfield.setTransform(135.4438,-182.951);
ranj.TextOffsetFixer.fix(this.bioTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bioTextfield).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BioEllis, new cjs.Rectangle(-58,-186,936.5,234.9), null);


(lib.TutorialButtonHitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ApkC3IAAltITJAAIAAFtg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialButtonHitarea, new cjs.Rectangle(-61.2,-18.2,122.5,36.5), null);


(lib.TutorialBackgroundScore = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// cutout BITMAPS
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(58,58,58,0)").ss(1,1,1).p("EhoagwrIAbAAMDQaAAAIAAHQMAAABaHMjQ1AAAg");
	this.shape.setTransform(-1.95,1503.225);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("rgba(64,64,64,0)").ss(1,1,1).p("Aq7o+IV3AAQB8AABYBYQBYBYAAB8IAAIlQAAB8hYBYQhYBYh8AAI13AAQh8AAhYhYQhYhYAAh8IAAolQAAh8BYhYQBYhYB8AAg");
	this.shape_1.setTransform(-418.15,-806.1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("rgba(0,255,0,0)").s().p("Aq7I/Qh8AAhYhYQhYhYAAh8IAAolQAAh8BYhYQBYhYB8AAIV3AAQB8AABYBYQBYBYAAB8IAAIlQAAB8hYBYQhYBYh8AAg");
	this.shape_2.setTransform(416.75,-806.1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#4A4A4A").s().p("EhogEdtMAAAhhYIAcAAMAAAl4pIgcAAMAAAhhYMDQ1AAAMAAABeaIAMAAMAAAGC3IgMAAIAAnQMjQZAAAMDQZAAAIAAHQMAAABaIgEAzFiDaQhYBYAAB8IAAImQAAB8BYBYQBYBYB8AAIV4AAQB8AABYhYQBYhYAAh8IAAomQAAh8hYhYQhYhYh8AAI14AAQh8AAhYBYgEhQvh3gQAAB8BYBYQBYBYB8AAIV4AAQB8AABYhYQBYhYAAh8IAAomQAAh8hYhYQhYhYh8AAI14AAIV4AAQB8AABYBYQBYBYAAB8IAAImQAAB8hYBYQhYBYh8AAI14AAQh8AAhYhYQhYhYAAh8IAAomQAAh8BYhYQBYhYB8AAQh8AAhYBYQhYBYAAB8IAAImg");
	this.shape_3.setTransform(-1.375,-13.675);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundScore, new cjs.Rectangle(-671.2,-1842.2,1338.7,3658.1000000000004), null);


(lib.TutorialBackgroundCharacter = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// cutout BITMAPS
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(58,58,58,0)").ss(1,1,1).p("EhouguiIAcAAMDQlAAAIAcAAMAAABdFMjRdAAAg");
	this.shape.setTransform(0.025,1524.7375);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("rgba(64,64,64,0)").ss(1,1,1).p("Aq7o+IV3AAQB8AABYBYQBYBYAAB8IAAIlQAAB8hYBYQhYBYh8AAI13AAQh8AAhYhYQhYhYAAh8IAAolQAAh8BYhYQBYhYB8AAg");
	this.shape_1.setTransform(-418.15,-806.1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#4A4A4A").s().p("EhoTEZ2MAAAhdGIAcAAMDQlgABIAcABMAAABdGgEhn3jAuIhSAAMAAAhZHMDRTAAAMAAABVdIAkAAMAAAGBHMjQlAABgEhPKiIgQhYBYAAB8IAAImQAAB8BYBYQBYBYB8AAIV4AAQB8AABYhYQBYhYAAh8IAAomQAAh8hYhYQhYhYh8AAI14AAQh8AAhYBYg");
	this.shape_2.setTransform(-2.675,18.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundCharacter, new cjs.Rectangle(-675.6,-1784.8,1346.9,3608.5), null);


(lib.TutorialBackgroundBird = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Background
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#4A4A4A").s().p("EhpBDDUMAAAg7UIBNAAMAAAkP/IhNAAMAAAg7UMDSDAAAMAAAA7UIglAAMAAAEP/IAlAAMAAAA7UgEhRrgHvMAAABPmQADBkCTAAMCfMAAAQCSAAAEhkMAAAhPmQgDhliTAAMifMAAAQiTAAgDBlg");
	this.shape.setTransform(-1.95,193.525);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(58,58,58,0)").s().p("EhPmApYQiSAAgEhkMAAAhPmQAEhlCSAAMCfNAAAQCSAAAEBlMAAABPmQgEBkiSAAg");
	this.shape_1.setTransform(-0.325,398.625);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundBird, new cjs.Rectangle(-675.1,-1747.2,1346.4,3190.7), null);


(lib.ProgressDotTween = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressDot();
	this.instance.setTransform(-15.5,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.5,-15.5,31,31);


(lib.Dot = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressDot_Selected();
	this.instance.setTransform(-15.5,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.5,-15.5,31,31);


(lib.PlaceholderRound = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.isSingleFrame = false;
	// timeline functions:
	this.frame_0 = function() {
		if(this.isSingleFrame) {
			return;
		}
		if(this.totalFrames == 1) {
			this.isSingleFrame = true;
		}
		this.removeChildAt(0);
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AifCgIAAk/IE/AAIAAE/g");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PlaceholderRound, new cjs.Rectangle(-16,-16,32,32), null);


(lib.FeedbackPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// body
	this.bodyTextfield = new cjs.Text("abcdef ", "39px 'Poppins SemiBold'", "#0F97FF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "center";
	this.bodyTextfield.lineHeight = 70;
	this.bodyTextfield.lineWidth = 149;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(0.0002,-35.25);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// Layer_2
	this.instance = new lib.FeedbackPanelBg();
	this.instance.setTransform(-113,-38);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPanel, new cjs.Rectangle(-113,-38,225,75.3), null);


(lib.factory7 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory7b();
	this.instance.setTransform(-617,-798);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.factory7, new cjs.Rectangle(-617,-798,1233,1596), null);


(lib.factory4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory4b();
	this.instance.setTransform(-398,-786.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.factory4, new cjs.Rectangle(-398,-786.5,796,1566), null);


(lib.factory3_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory2();
	this.instance.setTransform(-217.5,-458.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.factory3_1, new cjs.Rectangle(-217.5,-458.5,435,917), null);


(lib.factory1_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.factory1();
	this.instance.setTransform(-596.5,-520.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.factory1_1, new cjs.Rectangle(-596.5,-520.5,1278,993), null);


(lib.DarkTransparentBackground = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(35,32,33,0.4)").s().p("EhpiC7xMAAAl3hMDTFAAAMAAAF3hg");
	this.shape.setTransform(-0.025,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DarkTransparentBackground, new cjs.Rectangle(-675.5,-1201.7,1351,2403.4), null);


(lib.StartGameButtonFatter = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.instance = new lib.WhiteArrow();
	this.instance.setTransform(197,-31);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Text Up
	this.upLabelTextField = new cjs.Text("Antwort übermitteln", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 39;
	this.upLabelTextField.lineWidth = 368;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(14,-61.15);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Antwort übermitteln", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 39;
	this.overLabelTextField.lineWidth = 368;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(13.95,-61.15);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Antwort übermitteln", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 39;
	this.downLabelTextField.lineWidth = 368;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(13.95,-61.15);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Antwort übermitteln", "45px 'Poppins SemiBold'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 39;
	this.disabledLabelTextField.lineWidth = 368;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(14,-61.15);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance_1 = new lib.LongerMainButtonUp();
	this.instance_1.setTransform(-210,-63);

	this.instance_2 = new lib.LongerMainButtonHi();
	this.instance_2.setTransform(-210,-63);

	this.instance_3 = new lib.LongerMainButtonDown();
	this.instance_3.setTransform(-210,-63);

	this.instance_4 = new lib.LongerMainButtonDis();
	this.instance_4.setTransform(-210,-63);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-210,-63.1,518,126.1);


(lib.StartGameButton_Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Start\nStart", "16px 'Arial'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 23;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-18.3);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Start\nStart", "16px 'Arial'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 23;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-18.3);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Start\nStart", "16px 'Arial'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 23;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-18.3);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Start\nStart", "16px 'Arial'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 23;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-18.3);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-34.6,0.4,0.4323);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-34.85,0.4,0.4323);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-34.6,0.4,0.4323);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1,p:{y:-34.85}}]},1).to({state:[{t:this.instance_1,p:{y:-34.4}}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-34.8,173.2,73.9);


(lib.StartGameButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// arrow
	this.instance = new lib.WhiteArrow();
	this.instance.setTransform(97,-31);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4));

	// Text Up
	this.upLabelTextField = new cjs.Text("Weiter", "48px 'Poppins SemiBold'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 45;
	this.upLabelTextField.lineWidth = 289;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-39.45,-38.2);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Weiter", "48px 'Poppins SemiBold'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 45;
	this.overLabelTextField.lineWidth = 289;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-39.45,-38.2);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Weiter", "48px 'Poppins SemiBold'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 45;
	this.downLabelTextField.lineWidth = 289;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-39.45,-38.2);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Weiter", "48px 'Poppins SemiBold'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 45;
	this.disabledLabelTextField.lineWidth = 289;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-39.45,-38.2);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance_1 = new lib.MainButtonUp();
	this.instance_1.setTransform(-210,-63);

	this.instance_2 = new lib.MainButtonHi();
	this.instance_2.setTransform(-210,-63);

	this.instance_3 = new lib.MainButtonDown();
	this.instance_3.setTransform(-210,-63);

	this.instance_4 = new lib.MainButtonDis();
	this.instance_4.setTransform(-210,-63);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_4}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-210,-63,419,126);


(lib.CastCloseButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_5
	this.instance = new lib.CloseButtonUp();
	this.instance.setTransform(-77,-49);

	this.instance_1 = new lib.CloseButtonhi();
	this.instance_1.setTransform(-77,-49);

	this.instance_2 = new lib.CloseButtonDis();
	this.instance_2.setTransform(-77,-49);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-77,-49,153,97);


(lib.bg_grey = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0F97FF").s().p("EhpxCmgMAAAlM/MDTjAAAMAAAFM/g");
	this.shape.setTransform(-0.025,-0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.bg_grey, new cjs.Rectangle(-677,-1065.6,1354,2131.2), null);


(lib.BalloonNPC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.bodyTextfield = new cjs.Text("NPC text here eiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiii", "39px 'Poppins'", "#0E5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 56;
	this.bodyTextfield.lineWidth = 909;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-436,-262);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// Layer_1
	this.instance = new lib.textBalloon();
	this.instance.setTransform(-476,-294);

	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("AgeAgIA9g9IgLgC");
	this.shape.setTransform(289.85,-277.125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BalloonNPC, new cjs.Rectangle(-476,-294,984,175), null);


(lib.BalloonInfoBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.instance = new lib.QuestionTextFieldBG();
	this.instance.setTransform(-492,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BalloonInfoBG, new cjs.Rectangle(-509.9,-152.5,1019.9,305.1), null);


(lib.Background_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-667,-1054,1333,2108);


(lib.splashTextPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// startbutton
	this.button = new lib.StartGameButton();
	this.button.name = "button";
	this.button.setTransform(276.45,626.3,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// bodyTextField
	this.bodyTextfield = new cjs.Text("Du hast das Ziel in 01:47:03 erreicht.", "40px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 56;
	this.bodyTextfield.lineWidth = 875;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(68.35,460.648);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// titleTextField
	this.titleTextfield = new cjs.Text("Gut gemacht!", "bold 144px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 154;
	this.titleTextfield.lineWidth = 882;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(68.35,51.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// panelBG
	this.instance = new lib.SplashBGPanel();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.splashTextPanel, new cjs.Rectangle(0,0,1002,739), null);


(lib.Robert_Front_Relieved = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Brows
	this.instance = new lib.Man1_Brow();
	this.instance.setTransform(-89.65,-109.2,1,1,-6.9994);

	this.instance_1 = new lib.Man1_Brow();
	this.instance_1.setTransform(44.95,-115.55,1,1,6.9994);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Eyes
	this.instance_2 = new lib.Eyes_Blinking();
	this.instance_2.setTransform(2.15,-65);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Base
	this.instance_3 = new lib.Man1_Front_Base();
	this.instance_3.setTransform(-220.5,-327.5);

	this.instance_4 = new lib.Shadow_Front();
	this.instance_4.setTransform(-353,-47);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Robert_Front_Relieved, new cjs.Rectangle(-353,-327.5,700,1021.5), null);


(lib.IntrospectionButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabled
	this.disabled = new lib.IntrospectionScalableButtonDisabled();
	this.disabled.name = "disabled";
	this.disabled.setTransform(494,56,1,1,0,0,0,494,56);

	this.timeline.addTween(cjs.Tween.get(this.disabled).wait(1));

	// down
	this.down = new lib.IntrospectionScalableButtonDown();
	this.down.name = "down";
	this.down.setTransform(494,56,1,1,0,0,0,494,56);

	this.timeline.addTween(cjs.Tween.get(this.down).wait(1));

	// over
	this.over = new lib.IntrospectionScalableButtonOver();
	this.over.name = "over";
	this.over.setTransform(494,56,1,1,0,0,0,494,56);

	this.timeline.addTween(cjs.Tween.get(this.over).wait(1));

	// up
	this.up = new lib.IntrospectionScalableButtonUp();
	this.up.name = "up";
	this.up.setTransform(494,56,1,1,0,0,0,494,56);

	this.timeline.addTween(cjs.Tween.get(this.up).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.IntrospectionButton, new cjs.Rectangle(-0.5,-0.2,989.1,125.2), null);


(lib.MultipleSelectOptionButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3,selectedUp:4,selectedOver:5,selectedDown:6,selectedDisabled:7};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// vinkje 2
	this.instance = new lib.vinkje();
	this.instance.setTransform(-20,-15);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(8));

	// selectedDisabledLabelTextField
	this.selectedDisabledLabelTextField = new cjs.Text("Lass Ellis wissen, dass du ihr Auge fürs Detail schätzt.", "36px 'Poppins'", "#0F5184");
	this.selectedDisabledLabelTextField.name = "selectedDisabledLabelTextField";
	this.selectedDisabledLabelTextField.lineHeight = 52;
	this.selectedDisabledLabelTextField.lineWidth = 446;
	this.selectedDisabledLabelTextField.parent = this;
	this.selectedDisabledLabelTextField.setTransform(33,26.75);
ranj.TextOffsetFixer.fix(this.selectedDisabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDisabledLabelTextField).wait(8));

	// selectedDownLabelTextField
	this.selectedDownLabelTextField = new cjs.Text("Lass Ellis wissen, dass du ihr Auge fürs Detail schätzt.", "36px 'Poppins'", "#0F5184");
	this.selectedDownLabelTextField.name = "selectedDownLabelTextField";
	this.selectedDownLabelTextField.lineHeight = 52;
	this.selectedDownLabelTextField.lineWidth = 446;
	this.selectedDownLabelTextField.parent = this;
	this.selectedDownLabelTextField.setTransform(33,26.75);
ranj.TextOffsetFixer.fix(this.selectedDownLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedDownLabelTextField).wait(8));

	// selectedOverLabelTextField
	this.selectedOverLabelTextField = new cjs.Text("Lass Ellis wissen, dass du ihr Auge fürs Detail schätzt.", "36px 'Poppins'", "#0F5184");
	this.selectedOverLabelTextField.name = "selectedOverLabelTextField";
	this.selectedOverLabelTextField.lineHeight = 52;
	this.selectedOverLabelTextField.lineWidth = 446;
	this.selectedOverLabelTextField.parent = this;
	this.selectedOverLabelTextField.setTransform(33,26.75);
ranj.TextOffsetFixer.fix(this.selectedOverLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedOverLabelTextField).wait(8));

	// selectedUpLabelTextField
	this.selectedUpLabelTextField = new cjs.Text("Lass Ellis wissen, dass du ihr Auge fürs Detail schätzt.", "36px 'Poppins'", "#0F5184");
	this.selectedUpLabelTextField.name = "selectedUpLabelTextField";
	this.selectedUpLabelTextField.lineHeight = 52;
	this.selectedUpLabelTextField.lineWidth = 446;
	this.selectedUpLabelTextField.parent = this;
	this.selectedUpLabelTextField.setTransform(33,26.75);
ranj.TextOffsetFixer.fix(this.selectedUpLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.selectedUpLabelTextField).wait(8));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Lass Ellis wissen, dass du ihr Auge fürs Detail schätzt.", "36px 'Poppins'", "#0F5184");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 52;
	this.disabledLabelTextField.lineWidth = 446;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(33,26.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(8));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("Lass Ellis wissen, dass du ihr Auge fürs Detail schätzt.", "36px 'Poppins'", "#0F5184");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 52;
	this.downLabelTextField.lineWidth = 446;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(33,26.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(8));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("Lass Ellis wissen, dass du ihr Auge fürs Detail schätzt.", "36px 'Poppins'", "#0F5184");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 52;
	this.overLabelTextField.lineWidth = 446;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(33,26.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(8));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("Lass Ellis wissen, dass du ihr Auge fürs Detail schätzt.", "36px 'Poppins'", "#0F5184");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 52;
	this.upLabelTextField.lineWidth = 446;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(33,26.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(8));

	// hit
	this.hit = new lib.buttonHitArea();
	this.hit.name = "hit";
	this.hit.setTransform(245.75,139.95,0.5328,1.4065,0,0,0,461.4,100.4);

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(8));

	// Layer_1
	this.instance_1 = new lib.Artboard36();

	this.instance_2 = new lib.MCButtonHi();

	this.instance_3 = new lib.MCButtonDown();

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},1).to({state:[{t:this.instance_1}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-20,-15,516,372);


(lib.EndScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// gambit
	this.elem4 = new lib.Gambit();
	this.elem4.name = "elem4";
	this.elem4.setTransform(56,773.9,0.6939,0.6939,0,0,180,0,-108);

	this.timeline.addTween(cjs.Tween.get(this.elem4).wait(1));

	// Layer_2
	this.elem2 = new lib.factory1_1();
	this.elem2.name = "elem2";
	this.elem2.setTransform(194.2,1230.7,0.7215,0.7215,0,0,0,0.1,0.1);

	this.elem1 = new lib.factory7();
	this.elem1.name = "elem1";
	this.elem1.setTransform(-48.8,682.15,1,1,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elem1},{t:this.elem2}]}).wait(1));

	// textPanel
	this.textPanel = new lib.splashTextPanel();
	this.textPanel.name = "textPanel";
	this.textPanel.setTransform(-2,-470.5,1,1,0,0,0,501,369.5);

	this.timeline.addTween(cjs.Tween.get(this.textPanel).wait(1));

	// Layer_3
	this.instance = new lib.Ground_Iso();
	this.instance.setTransform(-667,240,1.0037,1.0037);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// bg
	this.bg = new lib.bg_grey();
	this.bg.name = "bg";
	this.bg.setTransform(-2.65,-1.3);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndScreenSkin, new cjs.Rectangle(-679.7,-1184.2,1759.1000000000001,2969), null);


(lib.Robert_surprised = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// You
	this.instance = new lib.Gambit_Back();
	this.instance.setTransform(-794,-76);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer_2
	this.instance_1 = new lib.Robert_Front_Relieved();
	this.instance_1.setTransform(240.3,-30.45);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Layer_3
	this.instance_2 = new lib.Ground_Straight();
	this.instance_2.setTransform(-667,192,1.0045,1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// bg
	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Robert_surprised, new cjs.Rectangle(-794,-1184.2,1873.4,2944.2), null);


(lib.ProgressDot_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {unselected:0,selected:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop()
	}
	this.frame_16 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(16).call(this.frame_16).wait(1));

	// Layer_1
	this.instance = new lib.ProgressDotTween("synched",0);
	this.instance.setTransform(0,0,0.9677,0.9677);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1.3226,scaleY:1.3226},16).wait(1));

	// Layer_4
	this.instance_1 = new lib.Dot("synched",0);
	this.instance_1.setTransform(0,0,0.6451,0.6451);
	this.instance_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:1.2903,scaleY:1.2903,alpha:1},16).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-20.4,-20.4,41,41);


(lib.TransitionScreenProps = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Plant_5();
	this.instance.setTransform(342.3,360.5);

	this.instance_1 = new lib.watercooler();
	this.instance_1.setTransform(-353,-389.3,1.0008,1.0008,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TransitionScreenProps, new cjs.Rectangle(-655.3,-394.5,1310.6,789), null);


(lib.StoryPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// closeButton
	this.toggle = new lib.CastCloseButton();
	this.toggle.name = "toggle";
	this.toggle.setTransform(380.85,752.2,1,1,0,0,0,11,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.toggle).wait(5));

	// text
	this.bodyTextfield = new cjs.Text("Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here ", "39px 'Poppins'", "#0F5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 54;
	this.bodyTextfield.lineWidth = 906;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-446,-480.0046);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(5));

	// text
	this.closeInstructionsTextfield = new cjs.Text("Tap to close", "39px 'Poppins SemiBold'", "#0F5184");
	this.closeInstructionsTextfield.name = "closeInstructionsTextfield";
	this.closeInstructionsTextfield.textAlign = "right";
	this.closeInstructionsTextfield.lineHeight = 69;
	this.closeInstructionsTextfield.lineWidth = 675;
	this.closeInstructionsTextfield.parent = this;
	this.closeInstructionsTextfield.setTransform(285.25,717);
ranj.TextOffsetFixer.fix(this.closeInstructionsTextfield);

	this.titleTextfield = new cjs.Text("The story so \nfar", "bold 96px 'Poppins ExtraBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 99;
	this.titleTextfield.lineWidth = 909;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-446.0006,-783);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.titleTextfield},{t:this.closeInstructionsTextfield}]}).wait(5));

	// panel bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EhD6BoOQkrAAjTjTQjSjSAAkrMAAAi57QAAkrDSjSQDTjTErAAMCH1AAAQErAADSDTQDTDSAAErMAAAC57QAAErjTDSQjSDTkrAAg");
	this.shape.setTransform(0.025,-8.1601,1,1.2705);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-507,-1000,1025.3,1839.3);


(lib.IntrospectionPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// buttons scalable
	this.bubbles = new lib.IntrospectionThoughtBubbles();
	this.bubbles.name = "bubbles";
	this.bubbles.setTransform(708,485.6,0.9129,0.9126,0,0,0,120.5,148.6);

	this.dialogOptionButton1 = new lib.IntrospectionButton();
	this.dialogOptionButton1.name = "dialogOptionButton1";
	this.dialogOptionButton1.setTransform(18,248,0.9992,0.9959);

	this.dialogOptionButton2 = new lib.IntrospectionButton();
	this.dialogOptionButton2.name = "dialogOptionButton2";
	this.dialogOptionButton2.setTransform(18,124,0.9992,0.9959);

	this.dialogOptionButton3 = new lib.IntrospectionButton();
	this.dialogOptionButton3.name = "dialogOptionButton3";
	this.dialogOptionButton3.setTransform(18,0,0.9992,0.9959);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dialogOptionButton3},{t:this.dialogOptionButton2},{t:this.dialogOptionButton1},{t:this.bubbles}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.IntrospectionPanel, new cjs.Rectangle(-15,0,1020.2,559.4), null);


(lib.InfoPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bioSLots
	this.ellis = new lib.BioEllis();
	this.ellis.name = "ellis";
	this.ellis.setTransform(-371.45,642.5,0.93,0.93,0,0,0,-0.6,0.8);

	this.james = new lib.BioJames();
	this.james.name = "james";
	this.james.setTransform(-371.45,423.7,0.93,0.93,0,0,0,-0.6,0.8);

	this.megan = new lib.BioMegan();
	this.megan.name = "megan";
	this.megan.setTransform(-371.45,204.9,0.93,0.93,0,0,0,-0.6,0.8);

	this.robert = new lib.BioRobert();
	this.robert.name = "robert";
	this.robert.setTransform(-371.45,-13.9,0.93,0.93,0,0,0,-0.6,0.8);

	this.player = new lib.BioGambit();
	this.player.name = "player";
	this.player.setTransform(-371.45,-232.7,0.93,0.93,0,0,0,-0.6,0.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.player},{t:this.robert},{t:this.megan},{t:this.james},{t:this.ellis}]}).wait(5));

	// closeButton
	this.toggle = new lib.CastCloseButton();
	this.toggle.name = "toggle";
	this.toggle.setTransform(-355.3,745.75,1,1,0,0,0,10.9,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.toggle).wait(5));

	// text
	this.closeInstructionsTextfield = new cjs.Text("Tap to close", "39px 'Poppins SemiBold'", "#0F5184");
	this.closeInstructionsTextfield.name = "closeInstructionsTextfield";
	this.closeInstructionsTextfield.lineHeight = 69;
	this.closeInstructionsTextfield.lineWidth = 675;
	this.closeInstructionsTextfield.parent = this;
	this.closeInstructionsTextfield.setTransform(-275.0001,716.9994);
ranj.TextOffsetFixer.fix(this.closeInstructionsTextfield);

	this.titleTextfield = new cjs.Text("Meet the cast.........................................", "50px 'Poppins SemiBold'", "#0F5184");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 88;
	this.titleTextfield.lineWidth = 891;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-443.0009,-518);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.episodeTitleTextfield = new cjs.Text("NameBlah\nBlahhh", "bold 96px 'Poppins ExtraBold'", "#0F5184");
	this.episodeTitleTextfield.name = "episodeTitleTextfield";
	this.episodeTitleTextfield.lineHeight = 99;
	this.episodeTitleTextfield.lineWidth = 941;
	this.episodeTitleTextfield.parent = this;
	this.episodeTitleTextfield.setTransform(-446.0006,-783);
ranj.TextOffsetFixer.fix(this.episodeTitleTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.episodeTitleTextfield},{t:this.titleTextfield},{t:this.closeInstructionsTextfield}]}).wait(5));

	// panel bg
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EhD6BoOQkrAAjTjTQjSjSAAkrMAAAi57QAAkrDSjSQDTjTErAAMCH1AAAQErAADSDTQDTDSAAErMAAAC57QAAErjTDSQjSDTkrAAg");
	this.shape.setTransform(0.025,-8.1601,1,1.2705);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(5));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-507,-1000,1025.3,1839.3);


(lib.MultipleSelectionPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_4
	this.elem11 = new lib.deskGambit_1();
	this.elem11.name = "elem11";
	this.elem11.setTransform(332.75,1098.2,0.7608,0.7608,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.elem11).wait(1));

	// submitButton
	this.submitButton = new lib.StartGameButtonFatter();
	this.submitButton.name = "submitButton";
	this.submitButton.setTransform(682.85,826.6,1,1,0,0,0,0.1,3.1);

	this.timeline.addTween(cjs.Tween.get(this.submitButton).wait(1));

	// Layer_2
	this.MSOptionButton6 = new lib.MultipleSelectOptionButton();
	this.MSOptionButton6.name = "MSOptionButton6";
	this.MSOptionButton6.setTransform(829.2,590.1,1,1,0,0,0,318.5,229);

	this.MSOptionButton5 = new lib.MultipleSelectOptionButton();
	this.MSOptionButton5.name = "MSOptionButton5";
	this.MSOptionButton5.setTransform(318.5,590.1,1,1,0,0,0,318.5,229);

	this.MSOptionButton4 = new lib.MultipleSelectOptionButton();
	this.MSOptionButton4.name = "MSOptionButton4";
	this.MSOptionButton4.setTransform(829.2,223.55,1,1,0,0,0,318.5,229);

	this.MSOptionButton3 = new lib.MultipleSelectOptionButton();
	this.MSOptionButton3.name = "MSOptionButton3";
	this.MSOptionButton3.setTransform(318.5,223.55,1,1,0,0,0,318.5,229);

	this.MSOptionButton2 = new lib.MultipleSelectOptionButton();
	this.MSOptionButton2.name = "MSOptionButton2";
	this.MSOptionButton2.setTransform(829.2,-143,1,1,0,0,0,318.5,229);

	this.MSOptionButton1 = new lib.MultipleSelectOptionButton();
	this.MSOptionButton1.name = "MSOptionButton1";
	this.MSOptionButton1.setTransform(318.5,-143,1,1,0,0,0,318.5,229);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.MSOptionButton1},{t:this.MSOptionButton2},{t:this.MSOptionButton3},{t:this.MSOptionButton4},{t:this.MSOptionButton5},{t:this.MSOptionButton6}]}).wait(1));

	// panelBG
	this.instance = new lib.MSAnswersBGPanel();
	this.instance.setTransform(-25,-395);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.MultipleSelectionPanel, new cjs.Rectangle(-110.5,-395,1137.5,1842.4), null);


(lib.PrevButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Previous", "14px 'Arial'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 25;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-56.45,-9);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Previous", "14px 'Arial'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 25;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-56.45,-9);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Previous", "14px 'Arial'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 25;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-56.45,-9);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Previous", "14px 'Arial'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 25;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-56.45,-9);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102,-17.9,122.5,36.5);


(lib.NextButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Next", "14px 'Arial'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 25;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-21.6,-9);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Next", "14px 'Arial'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 25;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-21.6,-9);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Next", "14px 'Arial'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 25;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-21.6,-9);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Next", "14px 'Arial'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 25;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-21.6,-9);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102,-17.9,122.5,36.5);


(lib.EpisodeButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// imageContainer
	this.imageContainer = new lib.EpisodeImages();
	this.imageContainer.name = "imageContainer";
	this.imageContainer.setTransform(310.15,-18,0.7317,0.7317);

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(4));

	// completedTextField
	this.completedTextField = new cjs.Text("Completed", "bold 33px 'Poppins'", "#B9CDDC");
	this.completedTextField.name = "completedTextField";
	this.completedTextField.lineHeight = 63;
	this.completedTextField.lineWidth = 758;
	this.completedTextField.parent = this;
	this.completedTextField.setTransform(-311.75,7);
	this.completedTextField._off = true;
ranj.TextOffsetFixer.fix(this.completedTextField);

	this.timeline.addTween(cjs.Tween.get(this.completedTextField).wait(3).to({_off:false},0).wait(1));

	// disabledLabelTextField
	this.disabledLabelTextField = new cjs.Text("Dissatisfaction", "bold 40px 'Poppins'", "#B9CDDC");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 56;
	this.disabledLabelTextField.lineWidth = 519;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-327,-49.5);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextfield
	this.downLabelTextField = new cjs.Text("Dissatisfaction", "bold 40px 'Poppins'", "#0F5184");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 56;
	this.downLabelTextField.lineWidth = 521;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-327,-48.9);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextfield
	this.overLabelTextField = new cjs.Text("Dissatisfaction", "bold 40px 'Poppins'", "#0F5184");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 56;
	this.overLabelTextField.lineWidth = 521;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-327,-48.9);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// upLabelTextfield
	this.upLabelTextField = new cjs.Text("Dissatisfaction", "bold 40px 'Poppins'", "#0F5184");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 56;
	this.upLabelTextField.lineWidth = 521;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-327,-48.9);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// bg
	this.instance = new lib.EpisodeButtonUp();
	this.instance.setTransform(-486,-127);

	this.instance_1 = new lib.EpisodeButtonHi();
	this.instance_1.setTransform(-486,-127);

	this.instance_2 = new lib.EpisodeButtonLo();
	this.instance_2.setTransform(-486,-127);

	this.instance_3 = new lib.EpisodeButtonDis();
	this.instance_3.setTransform(-486,-127);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).to({state:[{t:this.instance_3}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-486,-127,951,212);


(lib.AssetsButtonsDialogButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabled
	this.disabled = new lib.ConversationScalableButtonDisabled();
	this.disabled.name = "disabled";
	this.disabled.setTransform(-4.1,0.5,1,1,0,0,0,512.9,116.5);

	this.timeline.addTween(cjs.Tween.get(this.disabled).wait(1));

	// down
	this.down = new lib.ConversationScalableButtonDown();
	this.down.name = "down";
	this.down.setTransform(-4.1,0.5,1,1,0,0,0,512.9,116.5);

	this.timeline.addTween(cjs.Tween.get(this.down).wait(1));

	// over
	this.over = new lib.ConversationScalableButtonOver();
	this.over.name = "over";
	this.over.setTransform(-4.1,0.5,1,1,0,0,0,512.9,116.5);

	this.timeline.addTween(cjs.Tween.get(this.over).wait(1));

	// up
	this.up = new lib.ConversationScalableButtonUp();
	this.up.name = "up";
	this.up.setTransform(-4.1,0.5,1,1,0,0,0,512.9,116.5);

	this.timeline.addTween(cjs.Tween.get(this.up).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.AssetsButtonsDialogButton, new cjs.Rectangle(-517,-116,1013,123), null);


(lib.BalloonInfo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text
	this.bodyTextfield = new cjs.Text("[introductory remarks in this balloon]]]]]]]]]]]]", "39px 'Poppins'", "#0E5184");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 58;
	this.bodyTextfield.lineWidth = 923;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-445,-116);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// bg
	this.bg = new lib.BalloonInfoBG();
	this.bg.name = "bg";
	this.bg.setTransform(10,-303,1,1,0,0,0,0,-152);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BalloonInfo, new cjs.Rectangle(-482,-151,984,138), null);


(lib.EpisodeSelectButtonPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// episodeButton
	this.episodeButton = new lib.EpisodeButton();
	this.episodeButton.name = "episodeButton";
	this.episodeButton.setTransform(532,1067.45);

	this.episodeButton_1 = new lib.EpisodeButton();
	this.episodeButton_1.name = "episodeButton_1";
	this.episodeButton_1.setTransform(532,178.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.episodeButton_1},{t:this.episodeButton}]}).wait(1));

	// Layer_1
	this.instance = new lib.EpisodeSelectBGPanel();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EpisodeSelectButtonPanel, new cjs.Rectangle(0,0,1043,1203), null);


(lib.TransitionScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// titleTextField
	this.titleTextfield = new cjs.Text("Minigame \nLine2", "bold 96px 'Poppins ExtraBold'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 109;
	this.titleTextfield.lineWidth = 937;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-472.9523,-823.9989,1.0156,1);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// Layer_2
	this.props = new lib.TransitionScreenProps();
	this.props.name = "props";
	this.props.setTransform(59.9,826.45);

	this.timeline.addTween(cjs.Tween.get(this.props).wait(1));

	// bg
	this.bg = new lib.bg_grey();
	this.bg.name = "bg";
	this.bg.setTransform(-2.65,-1.3);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TransitionScreenSkin, new cjs.Rectangle(-679.7,-1184.2,1759.1000000000001,2405.2), null);


(lib.StoryPanelSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// content (closed)
	this.contents = new lib.StoryPanel();
	this.contents.name = "contents";
	this.contents.setTransform(2.95,-1737.15,1,1,0,0,0,0.5,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.contents).wait(1));

	// bg
	this.bg = new lib.DarkTransparentBackground();
	this.bg.name = "bg";
	this.bg.setTransform(-0.95,102.5);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.StoryPanelSkin, new cjs.Rectangle(-676.4,-2592.6,1755.8000000000002,3896.8), null);


(lib.InfoPanelSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// content (closed)
	this.contents = new lib.InfoPanel();
	this.contents.name = "contents";
	this.contents.setTransform(0.5,-1740.15,1,1,0,0,0,0.5,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.contents).wait(1));

	// bg
	this.bg = new lib.DarkTransparentBackground();
	this.bg.name = "bg";
	this.bg.setTransform(-0.95,102.5);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.InfoPanelSkin, new cjs.Rectangle(-676.4,-2595.6,1755.8000000000002,3899.8), null);


(lib.EpisodeSelectionScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// buttonPanel
	this.buttonPanel = new lib.EpisodeSelectButtonPanel();
	this.buttonPanel.name = "buttonPanel";
	this.buttonPanel.setTransform(-522,-355);

	this.timeline.addTween(cjs.Tween.get(this.buttonPanel).wait(1));

	// textPanel
	this.textPanel = new lib.NarratorTextPanel();
	this.textPanel.name = "textPanel";
	this.textPanel.setTransform(-506,-838);

	this.timeline.addTween(cjs.Tween.get(this.textPanel).wait(1));

	// Layer_2
	this.instance = new lib.factory1_1();
	this.instance.setTransform(184.55,852.25,0.7215,0.7215,0,0,0,0.1,0.1);

	this.instance_1 = new lib.factory3_1();
	this.instance_1.setTransform(-316.85,672.7,0.7215,0.7215);

	this.instance_2 = new lib.Gambit();
	this.instance_2.setTransform(-104.1,561.75,0.5918,0.5918,0,0,0,0,0.1);

	this.instance_3 = new lib.chimney();
	this.instance_3.setTransform(-770.55,483.4,0.7215,0.7215,0,0,0,-0.1,0.2);

	this.instance_4 = new lib.factory4();
	this.instance_4.setTransform(96.2,356,0.7215,0.7215,0,0,0,0.2,0.1);

	this.instance_5 = new lib.chimney();
	this.instance_5.setTransform(825.8,190,0.606,0.606,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Layer_3
	this.instance_6 = new lib.Teamtacticsepisodeselectsmaller();
	this.instance_6.setTransform(19,0);

	this.instance_7 = new lib.Ground_Iso();
	this.instance_7.setTransform(-667,39,1.0037,1.0037);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_7},{t:this.instance_6}]}).wait(1));

	// bg
	this.bg = new lib.bg_grey();
	this.bg.name = "bg";
	this.bg.setTransform(-2.65,-1.3);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EpisodeSelectionScreenSkin, new cjs.Rectangle(-820.6,-1184.2,1900,2768), null);


(lib.ProgressDots_MC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.dot3 = new lib.ProgressDot_1();
	this.dot3.name = "dot3";
	this.dot3.setTransform(47.85,0);

	this.dot1 = new lib.ProgressDot_1();
	this.dot1.name = "dot1";
	this.dot1.setTransform(-48.15,0);

	this.dot2 = new lib.ProgressDot_1();
	this.dot2.name = "dot2";
	this.dot2.setTransform(-0.15,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dot2},{t:this.dot1},{t:this.dot3}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ProgressDots_MC, new cjs.Rectangle(-63.1,-15,126,30), null);


(lib.DialogPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// |Dialog
	this.dialogOptionButton1 = new lib.AssetsButtonsDialogButton();
	this.dialogOptionButton1.name = "dialogOptionButton1";
	this.dialogOptionButton1.setTransform(502,532.4);

	this.dialogOptionButton2 = new lib.AssetsButtonsDialogButton();
	this.dialogOptionButton2.name = "dialogOptionButton2";
	this.dialogOptionButton2.setTransform(502,421);

	this.dialogOptionButton3 = new lib.AssetsButtonsDialogButton();
	this.dialogOptionButton3.name = "dialogOptionButton3";
	this.dialogOptionButton3.setTransform(502,311.15);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dialogOptionButton3},{t:this.dialogOptionButton2},{t:this.dialogOptionButton1}]}).wait(1));

	// bgPanel
	this.instance = new lib.DialogButtonsPanelBG();
	this.instance.setTransform(-30,161);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DialogPanel, new cjs.Rectangle(-30,161,1046,413), null);


(lib.TutorialScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button start
	this.button = new lib.StartGameButton_Overlay();
	this.button.name = "button";
	this.button.setTransform(317.2,757.55,2.3939,2.3939,0,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(4));

	// buttons
	this.prevButton = new lib.PrevButton();
	this.prevButton.name = "prevButton";
	this.prevButton.setTransform(-276.5,757.55,3,3,0,0,0,-41,0.1);

	this.nextButton = new lib.NextButton();
	this.nextButton.name = "nextButton";
	this.nextButton.setTransform(236.25,757.55,3,3,0,0,0,-38.7,0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.nextButton},{t:this.prevButton}]}).wait(4));

	// Progress dots
	this.progressDots = new lib.ProgressDots_MC();
	this.progressDots.name = "progressDots";
	this.progressDots.setTransform(-7.65,756.9,0.9,0.9,0,0,0,-0.1,0);

	this.timeline.addTween(cjs.Tween.get(this.progressDots).wait(4));

	// Titles
	this.titleTextfield = new cjs.Text("xMaking decisions", "20px 'Arial'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 35;
	this.titleTextfield.lineWidth = 283;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-423.5,-708,3,3);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(4));

	// Text
	this.bodyTextfield = new cjs.Text("• xAt certain moments you are asked to make a choice out of multiple options.", "14px 'Arial'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 25;
	this.bodyTextfield.lineWidth = 282;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-423.5,-540.2,3,3);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(4));

	// bg1
	this.bg1 = new lib.TutorialBackgroundBird();
	this.bg1.name = "bg1";
	this.bg1.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg1).wait(4));

	// bg2
	this.bg2 = new lib.TutorialBackgroundCharacter();
	this.bg2.name = "bg2";
	this.bg2.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg2).wait(4));

	// bg3
	this.bg3 = new lib.TutorialBackgroundScore();
	this.bg3.name = "bg3";
	this.bg3.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg3).wait(4));

	// tutorialDialogPanel
	this.tutorialDialogPanel = new lib.DialogPanel();
	this.tutorialDialogPanel.name = "tutorialDialogPanel";
	this.tutorialDialogPanel.setTransform(-498.85,20.15);

	this.timeline.addTween(cjs.Tween.get(this.tutorialDialogPanel).wait(4));

	// npcTextPanel
	this.npcBalloon = new lib.BalloonNPCtutorial();
	this.npcBalloon.name = "npcBalloon";
	this.npcBalloon.setTransform(-8.6,-419.65);

	this.timeline.addTween(cjs.Tween.get(this.npcBalloon).wait(4));

	// Gamescreen
	this.contents = new lib.InfoPanel();
	this.contents.name = "contents";
	this.contents.setTransform(-5.15,-1537.15,1,1,0,0,0,0.5,-0.1);

	this.contents_1 = new lib.StoryPanel();
	this.contents_1.name = "contents_1";
	this.contents_1.setTransform(-5.15,-1537.15,1,1,0,0,0,0.5,-0.1);

	this.instance = new lib.Robert_surprised();
	this.instance.setTransform(-3.5,67,1,1,0,0,0,-2,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.contents_1},{t:this.contents}]}).wait(4));

	// imageContainer
	this.imageContainer = new lib.PlaceholderRound();
	this.imageContainer.name = "imageContainer";

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(4));

	// bg
	this.bg = new lib.Background_1();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-795.5,-2595.5,1874.9,4418.7);


(lib.DialogScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// storyPanelButton
	this.storyPanelButton = new lib.StoryPanelButton();
	this.storyPanelButton.name = "storyPanelButton";
	this.storyPanelButton.setTransform(396.5,-787.5,1,1,0,0,0,102.5,50.5);

	this.timeline.addTween(cjs.Tween.get(this.storyPanelButton).wait(1));

	// castPanelButton
	this.castPanelButton = new lib.CastPanelButton();
	this.castPanelButton.name = "castPanelButton";
	this.castPanelButton.setTransform(-397.5,-787.5,1,1,0,0,0,102.5,50.5);

	this.timeline.addTween(cjs.Tween.get(this.castPanelButton).wait(1));

	// continueButton
	this.continueButton = new lib.StartGameButton();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(280,745.3,1,1,0,0,0,0,3.1);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// infoballoon (premise)
	this.infoBalloon = new lib.BalloonInfo();
	this.infoBalloon.name = "infoBalloon";
	this.infoBalloon.setTransform(-3.9,-565.9);

	this.timeline.addTween(cjs.Tween.get(this.infoBalloon).wait(1));

	// MultipleSelection
	this.multipleSelectionPanel = new lib.MultipleSelectionPanel();
	this.multipleSelectionPanel.name = "multipleSelectionPanel";
	this.multipleSelectionPanel.setTransform(0.05,47.55,1,1,0,0,0,500.7,128.8);

	this.timeline.addTween(cjs.Tween.get(this.multipleSelectionPanel).wait(1));

	// IntrospectionPanel
	this.introspectionPanel = new lib.IntrospectionPanel();
	this.introspectionPanel.name = "introspectionPanel";
	this.introspectionPanel.setTransform(-509.05,104.35);

	this.timeline.addTween(cjs.Tween.get(this.introspectionPanel).wait(1));

	// DialogPanel
	this.dialogPanel = new lib.DialogPanel();
	this.dialogPanel.name = "dialogPanel";
	this.dialogPanel.setTransform(-491.95,275.65);

	this.timeline.addTween(cjs.Tween.get(this.dialogPanel).wait(1));

	// npcTextPanel
	this.npcBalloon = new lib.BalloonNPC();
	this.npcBalloon.name = "npcBalloon";
	this.npcBalloon.setTransform(-8.6,-419.65);

	this.timeline.addTween(cjs.Tween.get(this.npcBalloon).wait(1));

	// imageContainer
	this.imageContainer = new lib.PlaceholderRound();
	this.imageContainer.name = "imageContainer";

	this.timeline.addTween(cjs.Tween.get(this.imageContainer).wait(1));

	// bg
	this.bg = new lib.Background_1();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	// bg color
	this.bg_1 = new lib.bg_grey();
	this.bg_1.name = "bg_1";
	this.bg_1.setTransform(-2.65,-1.3);

	this.timeline.addTween(cjs.Tween.get(this.bg_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DialogScreenSkin, new cjs.Rectangle(-679.7,-2595.5,1759.1000000000001,3961.6), null);


// stage content:
(lib.MainAssetsRedesign = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// assets
	this.feedbackPanel = new lib.FeedbackPanel();
	this.feedbackPanel.name = "feedbackPanel";
	this.feedbackPanel.setTransform(1525.85,-771,1,1,0,0,0,-3.5,31.4);

	this.timeline.addTween(cjs.Tween.get(this.feedbackPanel).wait(1));

	// episopdeselectscreen
	this.instance = new lib.EpisodeSelectionScreenSkin();
	this.instance.setTransform(-2690.55,1166.6,1,1,0,0,0,1,308.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// contextual info
	this.rulesPanel = new lib.InfoPanelSkin();
	this.rulesPanel.name = "rulesPanel";
	this.rulesPanel.setTransform(3404.35,630.65,1,1,0,0,0,0,-0.5);

	this.timeline.addTween(cjs.Tween.get(this.rulesPanel).wait(1));

	// tutorialScreen
	this.instance_1 = new lib.TutorialScreenSkin();
	this.instance_1.setTransform(-4384.25,538.35,1,1,0,0,0,-62,-358.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// story info
	this.instance_2 = new lib.StoryPanelSkin();
	this.instance_2.setTransform(3403.35,27.05,1,1,0,0,0,-1,-604.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// dialogscreen
	this.instance_3 = new lib.DialogScreenSkin();
	this.instance_3.setTransform(963.9,1266.05,1,1,0,0,0,423.9,395);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// transitionscreen
	this.instance_4 = new lib.TransitionScreenSkin();
	this.instance_4.setTransform(2054.05,870.95,1,1,0,0,0,0.5,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	// endscreen
	this.instance_5 = new lib.EndScreenSkin();
	this.instance_5.setTransform(-1041.5,870.95,1,1,0,0,0,0.5,-0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-4577.7,-1093.4,8656.6,3813);
// library properties:
lib.properties = {
	id: 'F7DD7F692B0D1D44A7B614DFFAE812BF',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#0F97FF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/MainAssets/Andrea_Side_Neutral_Open.png", id:"MainAssets_Andrea_Side_Neutral_Open", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Artboard36.png", id:"MainAssets_Artboard36", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Balloon01.png", id:"MainAssets_Balloon01", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/balloontail.png", id:"MainAssets_balloontail", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_disabled.png", id:"MainAssets_Button_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_down.png", id:"MainAssets_Button_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_up.png", id:"MainAssets_Button_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CharacterShadow.png", id:"MainAssets_CharacterShadow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CloseButtonDis.png", id:"MainAssets_CloseButtonDis", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CloseButtonhi.png", id:"MainAssets_CloseButtonhi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/CloseButtonUp.png", id:"MainAssets_CloseButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/deskGambit.png", id:"MainAssets_deskGambit", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/DialogButtonHi.png", id:"MainAssets_DialogButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/DialogButtonLo.png", id:"MainAssets_DialogButtonLo", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/DialogButtonsPanelBG.png", id:"MainAssets_DialogButtonsPanelBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/DialogButtonUp.png", id:"MainAssets_DialogButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode1Image.png", id:"MainAssets_Episode1Image", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode1ImageDone.png", id:"MainAssets_Episode1ImageDone", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode2Image.png", id:"MainAssets_Episode2Image", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode2ImageDone.png", id:"MainAssets_Episode2ImageDone", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/episode3Image.png", id:"MainAssets_episode3Image", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode3ImageDOne.png", id:"MainAssets_Episode3ImageDOne", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode4Image.png", id:"MainAssets_Episode4Image", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode4ImageDone.png", id:"MainAssets_Episode4ImageDone", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode5Image.png", id:"MainAssets_Episode5Image", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Episode5ImageDone.png", id:"MainAssets_Episode5ImageDone", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/EpisodeButtonDis.png", id:"MainAssets_EpisodeButtonDis", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/EpisodeButtonHi.png", id:"MainAssets_EpisodeButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/EpisodeButtonLo.png", id:"MainAssets_EpisodeButtonLo", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/EpisodeButtonUp.png", id:"MainAssets_EpisodeButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/EpisodeSelectBGPanel.png", id:"MainAssets_EpisodeSelectBGPanel", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Eye_Front_Open.png", id:"MainAssets_Eye_Front_Open", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/factory1.png", id:"MainAssets_factory1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/factory2.png", id:"MainAssets_factory2", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/factory3.png", id:"MainAssets_factory3", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/factory4b.png", id:"MainAssets_factory4b", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/factory7b.png", id:"MainAssets_factory7b", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPanelBg.png", id:"MainAssets_FeedbackPanelBg", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/gambit.png", id:"MainAssets_gambit", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/gambit_1.png", id:"MainAssets_gambit_1", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Gambit_Back.png", id:"MainAssets_Gambit_Back", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/gambit_closed.png", id:"MainAssets_gambit_closed", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Ground_Iso.png", id:"MainAssets_Ground_Iso", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Ground_Straight.png", id:"MainAssets_Ground_Straight", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LongerMainButtonDis.png", id:"MainAssets_LongerMainButtonDis", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LongerMainButtonDown.png", id:"MainAssets_LongerMainButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LongerMainButtonHi.png", id:"MainAssets_LongerMainButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/LongerMainButtonUp.png", id:"MainAssets_LongerMainButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonDis.png", id:"MainAssets_MainButtonDis", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonDown.png", id:"MainAssets_MainButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonHi.png", id:"MainAssets_MainButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MainButtonUp.png", id:"MainAssets_MainButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Man1_Brow.png", id:"MainAssets_Man1_Brow", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Man1_Front_Base.png", id:"MainAssets_Man1_Front_Base", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MCButtonDown.png", id:"MainAssets_MCButtonDown", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MCButtonHi.png", id:"MainAssets_MCButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Megan_Side_Neutral_Open.png", id:"MainAssets_Megan_Side_Neutral_Open", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MSAnswersBGPanel.png", id:"MainAssets_MSAnswersBGPanel", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/NarratorTextBGPanel.png", id:"MainAssets_NarratorTextBGPanel", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Paul_Side_Neutral_Open.png", id:"MainAssets_Paul_Side_Neutral_Open", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Plant5.png", id:"MainAssets_Plant5", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton.png", id:"MainAssets_PrevNextButton", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_disabled.png", id:"MainAssets_PrevNextButton_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_down.png", id:"MainAssets_PrevNextButton_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressDot.png", id:"MainAssets_ProgressDot", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressDot_Selected.png", id:"MainAssets_ProgressDot_Selected", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/QuestionTextFieldBG.png", id:"MainAssets_QuestionTextFieldBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Robert_Side_Neutral_Open.png", id:"MainAssets_Robert_Side_Neutral_Open", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Shadow_Front.png", id:"MainAssets_Shadow_Front", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/SplashBGPanel.png", id:"MainAssets_SplashBGPanel", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/StategyButtonHi.png", id:"MainAssets_StategyButtonHi", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/StrategyButtonLo.png", id:"MainAssets_StrategyButtonLo", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/StrategyButtonUp.png", id:"MainAssets_StrategyButtonUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TabButtonBGTT.png", id:"MainAssets_TabButtonBGTT", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TabButtonIconTTCastDis.png", id:"MainAssets_TabButtonIconTTCastDis", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TabButtonIconTTCastUp.png", id:"MainAssets_TabButtonIconTTCastUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TabButtonIconTTStoryDis.png", id:"MainAssets_TabButtonIconTTStoryDis", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TabButtonIconTTStoryUp.png", id:"MainAssets_TabButtonIconTTStoryUp", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Teamtacticsepisodeselectsmaller.png", id:"MainAssets_Teamtacticsepisodeselectsmaller", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/textBalloon.png", id:"MainAssets_textBalloon", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/vinkje.png", id:"MainAssets_vinkje", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/watercooler01.png", id:"MainAssets_watercooler01", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/WhiteArrow.png", id:"MainAssets_WhiteArrow", bundle:"MainAssets"}
	],
	preloads: []
};



})(lib.MainAssets = {}, images, ss, createjs);
module.exports = lib.MainAssets;